import { render, staticRenderFns } from "./ContentSave.vue?vue&type=template&id=d8fecec2&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContentSave.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/ContentSave.vue
// module id = 1710
// module chunks = 1